export const actionTypes: any = {
  // get
  GET_ALL_MEMBER_START: 'GET_ALL_MEMBER_START',
  GET_ALL_MEMBER_SUCCESS: 'GET_ALL_MEMBER_SUCCESS',
  GET_ALL_MEMBER_FINISH: 'GET_ALL_MEMBER_FINISH',

  // get Members
  GET_MEMBER_START: 'GET_MEMBER_START',
  GET_MEMBER_SUCCESS: 'GET_MEMBER_SUCCESS',
  GET_MEMBER_FINISH: 'GET_MEMBER_FINISH',

  // get Members
  GET_FEATURED_MEMBER_START: 'GET_FEATURED_MEMBER_START',
  GET_FEATURED_MEMBER_SUCCESS: 'GET_FEATURED_MEMBER_SUCCESS',
  GET_FEATURED_MEMBER_FINISH: 'GET_FEATURED_MEMBER_FINISH',

  // add Member
  ADD_MEMBER_START: 'ADD_MEMBER_START',
  ADD_MEMBER_SUCCESS: 'ADD_MEMBER_SUCCESS',
  ADD_MEMBER_FINISH: 'ADD_MEMBER_FINISH',
  RESET_MEMBER: 'RESET_MEMBER',

  // update MEMBER
  UPDATE_MEMBER_START: 'UPDATE_MEMBER_START',
  UPDATE_MEMBER_SUCCESS: 'UPDATE_MEMBER_SUCCESS',
  UPDATE_MEMBER_FINISH: 'UPDATE_MEMBER_FINISH',

  // delete MEMBER
  DELETE_MEMBER_START: 'DELETE_MEMBER_START',
  DELETE_MEMBER_SUCCESS: 'DELETE_MEMBER_SUCCESS',
  DELETE_MEMBER_FINISH: 'DELETE_MEMBER_FINISH',

  // Enable MEMBER
  ENABLE_MEMBER_REQUEST: 'ENABLE_MEMBER_REQUEST',
  ENABLE_MEMBER_SUCCESS: 'ENABLE_MEMBER_SUCCESS',
  ENABLE_MEMBER_FINISH: 'ENABLE_MEMBER_FINISH',

  // Disable MEMBER
  DISABLE_MEMBER_REQUEST: 'DISABLE_MEMBER_REQUEST',
  DISABLE_MEMBER_SUCCESS: 'DISABLE_MEMBER_SUCCESS',
  DISABLE_MEMBER_FINISH: 'DISABLE_MEMBER_FINISH',

  // Enable MEMBER
  SINGLE_ENABLE_MEMBER_REQUEST: 'SINGLE_ENABLE_MEMBER_REQUEST',
  SINGLE_ENABLE_MEMBER_SUCCESS: 'SINGLE_ENABLE_MEMBER_SUCCESS',
  SINGLE_ENABLE_MEMBER_FINISH: 'SINGLE_ENABLE_MEMBER_FINISH',

  // Disable MEMBER
  SINGLE_DISABLE_MEMBER_REQUEST: 'SINGLE_DISABLE_MEMBER_REQUEST',
  SINGLE_DISABLE_MEMBER_SUCCESS: 'SINGLE_DISABLE_MEMBER_SUCCESS',
  SINGLE_DISABLE_MEMBER_FINISH: 'SINGLE_DISABLE_MEMBER_FINISH',
  // sort
  SORT_MEMBER_START: 'SORT_MEMBER_START',
  SORT_MEMBER_SUCCESS: 'SORT_MEMBER_SUCCESS',
  SORT_MEMBER_FINISH: 'SORT_MEMBER_FINISH',
  SORT_MEMBER_RESET: 'SORT_MEMBER_RESET',
}
